import MonitorEmbarque from '../../../models/embarque/monitor_embarque'
import { TABLA_MONITOR_EMBARQUE_EXPORTADOR, TABLA_MONITOR_EMBARQUE_BUQUE, TABLA_MONITOR_BODEGA_DESTINO } from '../../../config/tables'
import { COLUMNAS_MONITOR_BUQUE, COLUMNAS_MONITOR_EXPORTADOR, COLUMNAS_POR_BODEGA_DESTINO } from './constantesMonitorEmbarque'
import { obtenerDatosPlanDeEmbarqueActivo } from '../../Buque/actions/PlanDeEmbarqueActions'

export function obtenerMonitorPorBuque () {
  return (dispatch) => {
    MonitorEmbarque.getMonitorEmbarqueBuque()
      .then((data) => {
        dispatch({ type: 'MONITOR_EMBARQUE_POR_BUQUE', data })
      })
      .catch((error) => {
        console.log(error)
      })
  }
}

export function actualizarMonitorEmbarquePorBuque () {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_MONITOR_EMBARQUE_BUQUE
    })

    MonitorEmbarque.getMonitorEmbarqueBuque().then(callback)
    function callback (data) {
      const customToolbar = null
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNAS_MONITOR_BUQUE,
          data: data,
          title: `Embarque por buque`,
          titleColor: 'white',
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: {
            customToolbar,
            viewColumns: false,
            pagination: false,
            search: false,
            download: false,
            tableBodyMaxHeight: '450px',
            print: false,
            filter: false
          }
        },
        id: TABLA_MONITOR_EMBARQUE_BUQUE
      })
    }
  }
}

export function actualizarEmbarqueExportador () {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_MONITOR_EMBARQUE_EXPORTADOR
    })

    MonitorEmbarque.getMonitorEmbarqueExportador().then(callback)
    function callback (data) {
      const customToolbar = null
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNAS_MONITOR_EXPORTADOR,
          data: data,
          title: 'Embarque por exportador',
          isLoading: false,
          titleColor: 'white',
          fixed2Decimales: false,
          extraOptions: {
            customToolbar,
            pagination: false,
            viewColumns: false,
            search: false,
            download: false,
            tableBodyMaxHeight: '450px',
            print: false,
            filter: false
          }
        },
        id: TABLA_MONITOR_EMBARQUE_EXPORTADOR
      })
    }
  }
}

export function actualizarMonitorBodega () {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_MONITOR_BODEGA_DESTINO
    })

    MonitorEmbarque.getMonitorEmbarqueBodega().then(callback)
    function callback (data) {
      const customToolbar = null
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNAS_POR_BODEGA_DESTINO,
          data: data,
          title: 'Embarque por bodega y destino',
          isLoading: false,
          titleColor: 'white',
          fixed2Decimales: false,
          extraOptions: {
            customToolbar,
            pagination: false,
            viewColumns: false,
            search: false,
            download: false,
            tableBodyMaxHeight: '450px',
            print: false,
            filter: false
          }
        },
        id: TABLA_MONITOR_BODEGA_DESTINO
      })
    }
  }
}

export function obtenerPlanDeEmbarqueActivo (titleColor) {
  return (dispatch) => {
    dispatch(obtenerDatosPlanDeEmbarqueActivo(titleColor))
  }
}
